export const CategoryContract  = {
    async index(page, per_page, search) {
        page;
        per_page;
        search;

        throw new Error("index_category not implemented");
    },
}